export default ({...props}) => {
  const {panelHighlight, themeGrey, size} = props.theme
  return `
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    gap:${size(0.5)}px;
    & > div {
     display: inline-flex;
     flex-flow:row wrap;
     justify-content:center;
      & > .active {
        color:${panelHighlight.foreground};
        text-decoration-line:none;
        & > p{
          display:inline-block;
          text-transform: uppercase
        }
         &:not(:last-child):after{
          content:"\\2022";
          margin-left:${size(1)}px;
          margin-right:${size(1)}px;
          color:${themeGrey.medium_emphasis_grey}
        }
      }
    }
    & p {
      margin-bottom:${size(0)}px;
    }

    `
}
